export default [
    {
        path: '/hierarchy/objectif',
        name: 'objectif_list',
        component: () => import('@/views/equipe/ObjectiveHierachicList.vue'),
        meta: { requiresAuth: true ,       requiresAdminOrHierarchy: true,        },  // Nécessite une authentification

      }, 

      {
        path: '/hierarchy/evaluation',
        name: 'evaluation_list',
        component: () => import('@/views/equipe/EvaluationHierachicList.vue'),
        meta: { requiresAuth: true ,requiresAdminOrHierarchy: true,},  // Nécessite une authentification

      },
    
]